interface AwsWafIntegrationApi {
  fetch: typeof fetch;
}

declare global {
  interface Window {
    AwsWafIntegration?: AwsWafIntegrationApi;
  }
}

export const wafFetch: typeof fetch = (input, init) => {
  if (window.AwsWafIntegration?.fetch) {
    return window.AwsWafIntegration.fetch(input, init);
  }
  return fetch(input, init);
};
